export default __webpack_public_path__ + "static/media/closeMedia.4a95a5f9.svg";